<template>
    <div class="card shadow-sm mb-5 p-5 card-flush overflow-hidden h-md-100">
      <button v-if="remove"
          type="button"
          class="btn-close position-absolute top-0 end-0 mt-2 me-4"
          aria-label="Remove"
          @click="remove"/>

        <div class="card-header">
          <div class="card-title">
              <h5 style="text-align: start">{{ title }}</h5>
          </div>
          <div class="card-toolbar">
            <ButtonDropdownFilter
                :btn-title="$t('crm.estimate.label.paymentType')"
                :options="paymentTypes"
                value-field="id"
                name-field="name"
                :border="true"
                v-model="query.payment_type_id"
            />
          </div>   
        </div>
        <Loader :is-loading="loading">
          <div class="card-body">
            <div class="row overflow-auto flex-nowrap min-w-100">
              <div class="col-12 col-md-6 col-lg-3" v-for="(status, index) in invoiceStatsByStatus" :key="index">
                <div class="card p-5" style="background-color: #0072CE0D;">
                  <div class="d-flex flex-stack">
                    <div class="symbol symbol-40px me-4">
                      <div class="symbol-label fs-2" :style="{backgroundColor: status.color}">
                        <i class="fas fa-file-alt fs-2" style="color: white;"></i>
                      </div>
                    </div>
                    <div class="d-flex align-items-center flex-row-fluid flex-wrap">
                      <div class="flex-grow-1 me-2">
                        <a v-if="filterStatus(status.name)" class="text-gray-800 fs-6 fw-bold">
                          {{filterStatus(status.name)[locale]}}
                        </a>
                        <span class="text-muted fw-bold d-block fs-7">{{status?.count}}</span>
                      </div>
                      <div>{{formattedLocalAmount(status?.amount)}} {{defaultCurrency?.symbol}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Loader>
    </div>  
</template>
<script setup>
import ButtonDropdownFilter from '@/components/ButtonDropdownFilter.vue';
import {  onMounted, ref, watch} from 'vue';
import { useStore } from 'vuex';
import {formattedLocalAmount} from "@/mixins/Helpers";
import { computed } from 'vue';
import { useLocales } from '@/composables/locales';
import Loader from '@/components/Loader.vue';

const store = useStore()
const {locale} = useLocales()

const props = defineProps({
  id:{type: String, required: true},
  title:{type: String, required: true},
  loading:{type: Boolean, default: false},
  loadStats:{type: Function, required: true},
  remove:{type: Function},
  start: { type: Date, required: false },
  end: { type: Date, required: false },

})
  
const query = ref({
    start_date: '',
    end_date: '',
    payment_type_id: '',
    contact_id: ''
})

const invoiceStatsByStatus = ref([])


const paymentTypes = computed(() => store.getters['payments/paymentTypes'])
const invoiceStatus = computed(() => store.getters['invoices/invoiceStatus'])
const defaultCurrency = computed(() => store.getters['company/getCompanyCurrency'])

watch(() => [props.start, props.end], () => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
})

watch(() => query.value, () => {
  if (query.value.start_date && query.value.end_date) {
    loadData();
  }
}, {deep: true})


function loadData(){
  if (!query.value.start_date || !query.value.end_date) {
    console.warn("Dates non définies, loadData ignorée");
    return;
  }
  if(isSafe(query.value.start_date) && isSafe(query.value.end_date)){
     Promise.all([
        props.loadStats({id:props.id,startDate: query.value.start_date, endDate: query.value.end_date, contact_id: query.value.contact_id, payment_type_id: query.value.payment_type_id}).then((res) => {
          invoiceStatsByStatus.value = res.data?.invoiceStatsByStatus || res?.response?.data;


        }),
        store.dispatch('payments/loadPaymentTypes'),
        store.dispatch('invoices/loadInvoiceStatus')

      
    ]).then(() => {
    }) 
  }
    
}

function filterStatus(value){
  let statistic = invoiceStatus.value?.find(status => status.value === value)
  return statistic
}
  
onMounted(() => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
})

function isSafe(date){
  if(!date || date === undefined )
    return false

  return true
}
</script>